import { updateConditionDescriptionAction } from 'editor/src/store/design/slice';
import { ConditionAddress } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';

const updateConditionDescriptionOperation =
  (address: ConditionAddress, description: string) => (dispatch: ThunkDispatch) => {
    dispatch(updateConditionDescriptionAction({ address, description }));
  };

export default updateConditionDescriptionOperation;
